import { store } from '@/app/store';
import { ProhibitIcon } from '@/assets/images';
import { AppIcon } from '@/components';
import { resetAlertModal, setAlertModal } from '@/components/AlertModalRoot/alertModalService';
import { blockUser, unblockUser } from '@/infrastructure/sdk';
import { i18n } from '@/localization/i18n';
import { blockOfflineAction, getUserIdFromJid, logger, showErrorToast, updateToast } from '@/shared/utils';
import { getUserDetails, getUserNickName, updateBlockUser } from '../model';

export const blockContactAction = async (jid, isBlocked) => {
   try {
      if (blockOfflineAction()) return;
      const res = await (isBlocked ? unblockUser(jid) : blockUser(jid));
      if (res.statusCode === 200) {
         const userId = getUserIdFromJid(jid);
         store.dispatch(updateBlockUser({ userId, isBlocked: !isBlocked }));
         const username = getUserNickName(userId);
         const message = isBlocked
            ? i18n.t('toast.USER_UNBLOCKED', { username })
            : i18n.t('toast.USER_BLOCKED', { username });
         const toastId = 'block_unblock_status';
         updateToast(toastId, message, { type: 'success', autoClose: 5000 });
         return true;
      } else {
         showErrorToast(res?.message);
         return false;
      }
   } catch (error) {
      logger.error(error, 'err');
      return false;
   }
};

export const handleToggleBlockClick = ({ e, jid }) => {
   try {
      const userId = getUserIdFromJid(jid);
      const user = getUserDetails(userId);
      const { isBlockedByMe = false } = user;
      const nickName = user.nickName || user.name || userId;
      e?.preventDefault?.();
      const modalId = 'unblockContactModal';

      setAlertModal({
         id: modalId,
         visible: true,
         icon: <AppIcon icon={<ProhibitIcon className="danger-icon" />} />,
         title: isBlockedByMe
            ? i18n.t('chat.UNBLOCK_CONFIRM', { name: nickName })
            : i18n.t('chat.BLOCK_CONFIRM', { name: nickName }),
         description: isBlockedByMe ? i18n.t('chat.UNBLOCK_DESC') : i18n.t('chat.BLOCK_DESC'),
         yesButton: isBlockedByMe ? i18n.t('chat.UNBLOCK') : i18n.t('chat.BLOCK'),
         noButton: i18n.t('common.CANCEL'),
         yesAction: () => {
            if (blockOfflineAction()) return false;
            blockContactAction(jid, isBlockedByMe);
            resetAlertModal(modalId);
         },
         noAction: () => resetAlertModal(modalId),
         onRequestClose: () => resetAlertModal(modalId),
         customClassName: 'delete-account-confirm-modal  alert-modal-delete-v2',
      });
   } catch (error) {
      logger.error(error, 'err');
   }
};
